export enum EnvelopesMutationTypes {
  SET_MY_ENVELOPES = 'SET_MY_ENVELOPES',
  SET_MY_ENVELOPES_ERROR = 'SET_MY_ENVELOPES_ERROR',
  SET_MY_ENVELOPES_PENDING = 'SET_MY_ENVELOPES_PENDING',
}